<template>
  <v-card-text class="text--primary">
    <viewer :class="$vuetify.theme.dark ? 'tui-dark' : null" v-if="content" :initialValue="content"></viewer>
    <v-container v-else>
      <v-row justify="center" align="center">
        <v-progress-circular indeterminate></v-progress-circular>
      </v-row>
    </v-container>
  </v-card-text>
</template>
<script>
import site from '../../../siteConfig'

export default {
  data () {
    return {
      content: ''
    }
  },
  created () {
    this.setContent()
  },
  methods: {
    setContent () {
      this.content =
`
# 1. 개인정보의 처리 목적
${site.title}(‘${site.url}’이하 ‘${site.title}’) 는 다음의 목적을 위하여 개인정보를 처리하고 있으며, 다음의 목적 이외의 용도로는 이용하지 않습니다. - 고객 가입의사 확인, 고객에 대한 서비스 제공에 따른 본인 식별.인증, 회원자격 유지.

# 2. 개인정보의 처리 및 보유 기간
① ${site.title}는 정보주체로부터 개인정보를 수집할 때 동의 받은 개인정보 보유․이용기간 또는 법령에 따른 개인정보 보유․이용기간 내에서 개인정보를 처리․보유합니다.

② 구체적인 개인정보 처리 및 보유 기간은 다음과 같습니다.

- 접속에 관한 기록 - 통신비밀보호법 제15조의2 및 시행령 제41조에 의거 3개월간 보관
- 소비자의 불만 또는 분쟁처리에 관한 기록 - 전자상거래 등에서의 소비자보호에 관한 법룔 제6조 및 시행령 제6조에 의거 3년간 보관

# 3. 처리하는 개인정보의 항목
${site.title}는 다음의 개인정보 항목을 처리하고 있습니다.

수집하는 개인정보 필수항목

- 이메일
- 프로필사진

# 4. 개인정보의 파기
${site.title}는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.

## 파기 절차
이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.

## 파기 기한
이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.

# 5. 개인정보 보호책임자
${site.title}는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.

개인정보 보호책임자

성명 : ${site.owner}

연락처 : ${site.email}

# 6. 개인정보 처리방침 변경
이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.

# 8. 개인정보의 안전성 확보 조치 
${site.title}는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.
## 해킹 등에 대비한 기술적 대책
${site.title}는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.

## 개인정보에 대한 접근 제한
개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
`
    }
  }
}
</script>
